<template>
  <div
    class="fullPageContent"
    v-bind:class="{ closed: closeNavigation, open: !closeNavigation }"
  >
    <DashboardHeader
      v-bind:scrollButtonEnable="scrollButtonEnable"
      @menuButtonClicked="menuButtonClicked($event)"
    ></DashboardHeader>
    <section class="allP">
      <div class="content wp710 noPaddResponsive" ref="div1">
        <hr id="hrShadow" />
        <ProjectsList></ProjectsList>
      </div>
    </section>
  </div>
</template>
<script>
import DashboardHeader from "./Dashboard/Header";
import ProjectsList from "./Dashboard/Projects";

import { formatDate } from "../helpers";
export default {
  data() {
    return {
      password: "",
      email: "",
      isPahse2Enable: false,
      notCompleted: true,
      scrollButtonEnable: true,
      closeNavigation: true,
    };
  },
  created() {
    this.password = this.$route.params.password;
    this.email = this.$route.params.email;
  },
  components: {
    DashboardHeader,
    ProjectsList,
  },
  computed: {
    user() {
      return this.$store.getters["user/user"];
    },
    projects() {
      return this.$store.getters["user/projects"];
    },
    onboardingProjects() {
      return this.$store.getters["user/onboardingProjects"];
    },
    status() {
      return this.$store.getters["user/status"];
    },
  },
  mounted() {
    console.log('Dashboard mounted START');
    console.log(this.user);
    this.checkUser();
    if(this.user.name == 'not defined' || this.user.surname == 'not defined'){
      this.loadTransactions();
      console.log('to test on prod');
    }
    console.log('Dashboard mounted END');
  },
  methods: {
    checkUser() {
      if (this.checkVerificatioCode() === false) {
        this.checkUserStatus();
      }
    },
    checkVerificatioCode() {
      console.log('checkVerificatioCode START');
      console.log('this.user');
      console.log(this.user);
      if (this.user.verificationCode) {
        let email = this.email;
        let password = this.password;

        console.log('email');
        console.log(email);

        if (email && password) {
          this.$router.push({
            name: "verification",
            params: { email: email, password: password },
          });
          return true;
        }

      }
      return false;
    },
    checkUserStatus() {
      console.log('checkUserStatus this.status');
      console.log(this.status);
      if (this.status.status == "2") {
        this.getFirstOnboaringProjectLink();
      }
    },
    getFirstOnboaringProjectLink() {
      if (this.onboardingProjects.length) {
        let project = this.onboardingProjects.shift();
        this.$router.push({
          name: "completeregistration",
          params: { onboardingUrl: project.url },
        });
        return;
      }
      //unkown error now state==2  and thereis no onboarding project
    },
    loadTransactions() {
      this.$store.dispatch("user/userinfo");
    },
    goto(refName) {
      var element = this.$refs[refName];
      var top = element.offsetTop;
      window.scrollTo({ top: top, left: 0, behavior: "smooth" });
    },
    formatDate,
    menuButtonClicked(closeNavigation) {
      this.closeNavigation = closeNavigation;
    },
  },
};
</script>
<style>

.vue-typer .custom.char.typed {
  color: #ffffff;
}
.vue-typer .custom.caret {
  display: none;
}
</style>